import React, { useState, useEffect } from "react";
import { Modal, Input, Button, message } from "antd";
import { patchAdmissionApi } from "../../../../services/op.service";
import useQuery from "../../../../hooks/useQuery";
import modalStyles from "../../../PatientsIP/PatientGallery/galleryCompactModal.module.css";

const AddLabelModalOP = ({ visible, onClose, onAdded, labels }) => {
  const params = useQuery();
  const [labelName, setLabelName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );
  const folders = labels;

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const handleAddLabel = async () => {
    if (!labelName) {
      message.error("Please enter a label name");
      return;
    }

    if (folders.map((f) => f.toLowerCase()).includes(labelName.toLowerCase())) {
      return message.error("This label already exists");
    }

    setLoading(true);
    try {
      folders.push(labelName);
      const payload = { gallery_folders: folders, admission: params?.aid };
      const response = await patchAdmissionApi(params?.aid, payload);

      if (response.status === 201 || response.status === 200) {
        message.success("Label added successfully!");
        setLabelName("");
        onAdded();
        onClose();
      } else {
        message.error("Failed to add label");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong while adding label");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Label"
      open={visible}
      onCancel={onClose}
      width={isMobile ? "min(350px, calc(100vw - 24px))" : 350}
      {...(isMobile ? { centered: false } : {})}
      wrapClassName={isMobile ? modalStyles.compactModalWrap : undefined}
      className={isMobile ? modalStyles.compactForm : undefined}
      styles={
        isMobile
          ? {
              body: {
                maxWidth: "100%",
                overflowX: "hidden",
                boxSizing: "border-box",
              },
            }
          : undefined
      }
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="add"
          type="primary"
          loading={loading}
          onClick={handleAddLabel}
        >
          Add
        </Button>,
      ]}
    >
      <Input
        placeholder="Enter label name"
        value={labelName}
        onChange={(e) => setLabelName(e.target.value)}
        style={isMobile ? { width: "100%" } : undefined}
      />
    </Modal>
  );
};

export default AddLabelModalOP;
